<template>
    <div>
        <vs-table search stripe border description :sst="true" :data="table.data" :max-items="table.length"
            :total="table.total" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort">
            <template slot="header">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of
                            {{ this.table.total }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
                            <span>{{ item }}</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </template>
            <template slot="thead">
                <vs-th>Action</vs-th>
                <vs-th sort-key="">Buying Price Code / Name</vs-th>
                <vs-th sort-key="">Warehouse</vs-th>
                <vs-th sort-key="">Supplier</vs-th>
                <vs-th sort-key="">Validity</vs-th>
                <vs-th sort-key="">Timestamps</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <div class="vx-input-group flex" v-if="checkStatus == 'Released'">
                            <vx-tooltip text="View">
                                <vs-button v-if="hasPermission('view')" class="mr-1" size="small" color="grey"
                                    icon-pack="feather" icon="icon-eye" @click="handleView(tr.id, 'Detail')" />
                            </vx-tooltip>
                            <!-- <vx-tooltip text="Amend">
                                <vs-button class="mr-1" size="small" color="primary" icon-pack="feather" icon="icon-copy" 
                                @click="handleAmend(tr.id)" />
                            </vx-tooltip> -->
                            <vx-tooltip text="Set to Expired">
                                <vs-button v-if="hasPermission('edit')" class="mr-1" size="small" color="danger"
                                    icon-pack="feather" icon="icon-x" @click="handleExpired(tr.id)" />
                            </vx-tooltip>
                        </div>
                        <div class="vx-input-group flex" v-if="checkStatus == 'New' || checkStatus == 'Inquiry'">
                            <vx-tooltip text="Edit">
                                <vs-button v-if="hasPermission('edit')" class="mr-1" size="small" color="warning"
                                    icon-pack="feather" icon="icon-edit" @click="handleEdit(tr.id)" />
                            </vx-tooltip>
                            <vx-tooltip text="Cancel">
                                <vs-button v-if="hasPermission('cancel')" class="mr-1" size="small" color="danger"
                                    icon-pack="feather" icon="icon-x" @click="handleCancel(tr.id)" />
                            </vx-tooltip>
                            <vx-tooltip text="Confirm">
                                <vs-button v-if="hasPermission('edit')" class="mr-1" size="small" color="success"
                                    icon-pack="feather" icon="icon-check" @click="handleConfirm(tr.id)" />
                            </vx-tooltip>
                        </div>
                        <div class="vx-input-group flex" v-if="checkStatus == 'Log'">
                            <vx-tooltip text="View">
                                <vs-button v-if="hasPermission('edit')" class="mr-1" size="small" color="grey"
                                    icon-pack="feather" icon="icon-eye" @click="handleAmend(tr.id)" />
                            </vx-tooltip>
                        </div>
                        <div class="vx-input-group flex" v-if="checkStatus == 'Expired'">
                            <vx-tooltip text="View">
                                <vs-button v-if="hasPermission('view')" class="mr-1" size="small" color="grey"
                                    icon-pack="feather" icon="icon-eye" @click="handleView(tr.id, 'Expired')" />
                            </vx-tooltip>
                            <vx-tooltip text="Copy">
                                <vs-button v-if="hasPermission('edit')" class="mr-1" size="small" color="primary"
                                    icon-pack="feather" icon="icon-copy" @click="handleCopy(tr.id)" />
                            </vx-tooltip>
                        </div>
                        <div class="vx-input-group flex"
                            v-if="checkStatus == 'Waiting' || checkStatus == 'Rejected' || checkStatus == 'Canceled'">
                            <vx-tooltip text="View">
                                <vs-button v-if="hasPermission('view')" class="mr-1" size="small" color="grey"
                                    icon-pack="feather" icon="icon-eye" @click="handleView(tr.id, 'Detail')" />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                    <vs-td>{{ tr.code }} / {{ tr.name }}</vs-td>
                    <vs-td>{{ tr.warehouses }}</vs-td>
                    <vs-td>{{ tr.supplier_code }} {{ tr.supplier_name }}</vs-td>
                    <vs-td>{{ formatDate(tr.valid_from) }} ~ {{ formatDate(tr.valid_to) }}</vs-td>
                    <vs-td>
                        <p>Created by : {{ tr.created_by_name }}</p>
                        <p>Created at : {{ formatDateTime(tr.created_at) }}</p>
                        <p>Updated by : {{ tr.updated_by ? tr.updated_by_name : "-" }}</p>
                        <p>Updated at : {{ tr.updated_by ? formatDateTime(tr.updated_at) : "-" }}</p>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />

        <!-- <vs-prompt
            class="vx-row mb-6"
            @accept="acceptReplace"
            :active.sync="activePrompt"
            :title="'Validation'"
            :accept-text="'Accept'">
            <div class="w-full row">
                <vs-table stripe border description :sst="true" :data="textPrompt">
                    <template slot="thead">
                        <vs-th>No</vs-th>
                        <vs-th sort-key="">Notes</vs-th>
                    </template>
                
                    <template slot-scope="{ data }">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>{{ indextr+1 }}</vs-td>
                            <vs-td>{{ tr }}</vs-td>
                        </vs-tr>
                        
                    </template>
                </vs-table>
            </div>
        </vs-prompt> -->
        <vs-popup :active.sync="activePrompt" title="Information">
            <vs-table :style="{ width: '100%' }" :sst="false" :data="textPrompt">
                <template slot="thead">
                    <vs-th>No</vs-th>
                    <vs-th>Notes</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            {{ indextr + 1 }}
                        </vs-td>
                        <vs-td>
                            {{ tr }}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <div class="vx-row mt-4">
                <div class="vx-col w-full text-center">
                    <vs-button v-if="!overwriteBtn" @click="acceptReplace()" color="grey" class="">
                        CLOSE
                    </vs-button>
                    <div class="vx-input-group flex justify-center" v-if="overwriteBtn">
                        <vs-button title="Cancel" color="grey" @click="acceptReplace()">
                            CANCEL
                        </vs-button>
                        <vs-button title="Overwrite" class="ml-2" color="primary" @click="handleReplace()">
                            OVERWRITE
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<script>
import moment from "moment";
export default {
    components: {},
    props: {
        draw: {
            type: Number,
        },
        warehouseId: {
            type: Array,
        },
        supplierId: {
            type: Array,
        },
        status: {
            type: String,
        },
    },
    data() {
        return {
            activePrompt: false,
            overwriteBtn: false,
            textPrompt: [],
            bpId: 0,
            supplier: "",
            bpToReplace: [],
            codesToReplace: "",
            confirmId: null,
            table: this.tableDefaultState(),
        };
    },
    methods: {
        tableDefaultState() {
            return {
                data: [],
                length: 10,
                page: 1,
                search: "",
                order: "",
                sort: "desc",
                total: 0,
                totalPage: 1,
                totalSearch: 0,
                limits: [10, 25, 50, 100, "All"],
                start: 1,
                end: 0,
                permission: [],
            };
        },
        handleSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
            this.getData();
        },
        handleChangePage(page) {
            this.table.page = page;
            this.getData();
        },
        handleSort(key, active) {
            this.table.order = key;
            this.table.sort = active;
            this.getData();
        },
        handleChangelength(val) {
            this.table.length = val == "All" ? this.table.total : val;
            this.table.page = 1;
            this.getData();
        },
        handleClose() {
            this.getData();
            this.$emit("close");
        },
        getData() {
            this.$vs.loading();
            this.$http
                .get(this.$store.state.master.buyingPrice.baseUrlPath, {
                    params: {
                        length: this.table.length,
                        page: this.table.page,
                        search: this.table.search,
                        order: this.table.order,
                        sort: this.table.sort,
                        warehouse_id: this.warehouseId.slice(),
                        supplier_id: this.supplierId.slice(),
                        status: this.status,
                    }
                })
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.table.total = resp.data.total_record;
                        this.table.totalPage = resp.data.total_page;
                        this.table.totalSearch = resp.data.total_record_search;
                        this.table.length = resp.data.total_record_per_page;
                        this.table.data = resp.data.records;
                        this.setStartEnd();
                    } else {
                        console.log(resp)
                    }
                });
        },
        setStartEnd() {
            let valStart =
                this.table.length * this.table.page - this.table.length + 1;

            if (valStart > this.table.total) {
                valStart = 1;
            }
            if (this.table.total == 0) {
                valStart = 0;
            }
            let valEnd = this.table.length * this.table.page;

            if (valEnd > this.table.total) {
                valEnd = this.table.total;
            }

            if (
                this.table.totalSearch < this.table.total &&
                this.table.search != ""
            ) {
                valEnd = this.table.totalSearch;
            }

            this.table.start = valStart;
            this.table.end = valEnd;
        },
        handleConfirm(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "success",
                title: `Confirm`,
                text: "Confirm this data",
                accept: () => this.acceptConfirm(id),
            });
        },
        acceptConfirm(id) {
            this.$vs.loading();
            this.$http
                .get(this.$store.state.master.buyingPrice.baseUrlPath + "/change-status/waiting/" + id)
                .then((resp) => {
                    this.$vs.loading.close();
                    console.log(resp)
                    if (resp.code == 200) {
                        // let str = "There is active DBP 080524.00009 for SKU 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306, 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd.;There is active DBP 080524.00009 for SKU 857306 in warehouse W3214. Please ammend insteadasdasd."
                        this.textPrompt = resp.message.split(";");
                        this.activePrompt = true
                        if (resp.message != "" && resp.data.is_replacable == 1) {
                            this.overwriteBtn = true
                            this.bpId = id
                            this.bpToReplace = resp.data.existing
                        }
                        console.log(this.textPrompt)
                        // this.$vs.dialog({
                        //     type: "alert",
                        //     color: "success",
                        //     title: `Information`,
                        //     text: "",
                        // });
                        // this.$vs.notify({
                        //     color: "success",
                        //     title: "Success",
                        //     text: resp.message,
                        //     position: "top-right",
                        //     iconPack: "feather",
                        //     icon: "icon-x-circle",
                        //     time: "5000",
                        // });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                            time: "6000",
                        });
                    }
                    // replace tidak digunakan
                    // else {
                    //     if (resp.data.length != 0 && resp.data.sts == "replace"){
                    //         var codes = ""
                    //         resp.data.existing.forEach((el, idx) => {
                    //             codes += el.Code
                    //             if (idx !== resp.data.existing.length - 1) {
                    //                 codes += ", ";
                    //             }
                    //         });
                    //         this.bpId = id
                    //         this.supplier = resp.data.supplier
                    //         this.codesToReplace = codes
                    //         this.bpToReplace = resp.data.existing
                    //         this.activePrompt = true
                    //         // this.$vs.dialog({
                    //         //     type: "confirm",
                    //         //     color: "primary",
                    //         //     title: resp.message,
                    //         //     text: `
                    //         //         There are some items that already exist in the buying price for supplier ${resp.data.supplier}.
                    //         //         Do you want to replace the existing buying price with the code ${codes}
                    //         //     `,
                    //         //     accept: () => this.acceptReplace(id, resp.data.existing),
                    //         // });
                    //     }else{
                    //         this.$vs.notify({
                    //             color: "danger",
                    //             title: "Error",
                    //             text: resp.message,
                    //             position: "top-right",
                    //             iconPack: "feather",
                    //             icon: "icon-x-circle",
                    //         });
                    //     }
                    // }
                    this.getData();
                })
                .catch((error) => {
                    this.$vs.loading.close();
                    console.log(error);
                });
        },
        handleReplace() {
            this.$vs.loading();
            let form = new FormData();
            form.append("existing", JSON.stringify(this.bpToReplace));

            this.$http
                .post(this.$store.state.master.buyingPrice.baseUrlPath + "/replace/" + this.bpId, form)
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                            time: "5000",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                            time: "5000",
                        });
                    }
                    this.acceptReplace();
                    this.getData();
                })
                .catch((error) => {
                    this.$vs.loading.close();
                    console.log(error);
                });
        },
        acceptReplace() {
            this.activePrompt = false
            this.textPrompt = []
            this.bpId = 0
            this.bpToReplace = []
        },
        handleCancel(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Cancel`,
                text: "Cancel this data",
                accept: () => this.acceptCancel(id),
            });
        },
        acceptCancel(id) {
            this.$vs.loading();
            this.$http
                .get(this.$store.state.master.buyingPrice.baseUrlPath + "/change-status/canceled/" + id)
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: "Canceled successfully",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                    this.getData();
                })
                .catch((error) => {
                    this.$vs.loading.close();
                    console.log(error);
                });
        },
        handleExpired(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Expired`,
                text: "Set this data to Expired",
                accept: () => this.acceptExpired(id),
            });
        },
        acceptExpired(id) {
            this.$vs.loading();
            this.$http
                .get(this.$store.state.master.buyingPrice.baseUrlPath + "/change-status/expired/" + id)
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: "successfully set to Expired",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                    this.getData();
                })
                .catch((error) => {
                    this.$vs.loading.close();
                    console.log(error);
                });
        },
        handleCopy(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "primary",
                title: `Copy`,
                text: "Copy this buying price and set to Draft",
                accept: () => this.acceptCopy(id),
            });
        },
        acceptCopy(id) {
            this.$vs.loading();
            this.$http
                .get(this.$store.state.master.buyingPrice.baseUrlPath + "/copy/" + id)
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: "Successfully Copied with new Code : " + resp.data,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                            time: "10000",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                            time: "10000",
                        });
                    }
                    this.getData();
                })
                .catch((error) => {
                    this.$vs.loading.close();
                    console.log(error);
                });
        },
        handleView(id, tab) {
            console.log("tab in button :", tab)
            this.$router.push({
                name: this.$store.state.master.buyingPrice.baseRouterName + ".detail",
                params: { id: id, tab: tab },
            });
        },
        handleEdit(id) {
            this.$router.push({
                name: this.$store.state.master.buyingPrice.baseRouterName + ".form",
                params: { id: id, tab: this.status },
            });
        },
        handleAmend(id) {
            this.$router.push({
                name: this.$store.state.master.buyingPrice.baseRouterName + ".form-amend",
                params: { id: id, tab: this.status },
            });
        },
        getPermission() {
            this.$vs.loading();
            this.$http
                .get("/api/account/v1/permission", {
                    params: {
                        module: "buying-price",
                        source: "WMS"
                    }
                })
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code === 200) {
                        this.table.permission = resp.data;
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                });
        },
    },
    mounted() {
        this.getPermission();
    },
    watch: {
        // sourceWarehouseId() {
        //     this.getData();
        // },
        // transactionDate() {
        //     this.getData();
        // },
        // status() {
        //     this.getData();
        // },
        draw(newVal, oldVal) {
            console.log(newVal, oldVal)
            console.log("watch")
            this.getData();
        },
    },
    computed: {
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('YYYY-MM-DD');
            };
        },
        formatDateTime: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('YYYY-MM-DD HH:mm:ss');
            };
        },
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
        checkStatus() {
            return this.status;
        },
        hasPermission() {
            return (guardName) => {
                return this.table.permission.some((perm) => perm.GuardName === guardName);
            };
        },
    },
};
</script>
<style>
.con-vs-popup>.vs-popup {
    width: 40%;
    max-width: 70% !important;
}
</style>